import styled from 'styled-components';
import HorrorBird from 'products/global/assets/img/birds/horror.png';
import Spinner from 'components/Spinner';
import Alert from 'components/Alert';
import { TextInput } from 'components/Inputs';
import { sizes } from 'style';
import Container from 'components/Container';

export const ForgotPasswordContainer = styled(Container)`
  padding-bottom: 0;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-around;

  @media ${sizes.desktop} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const Bird = styled.img.attrs({ src: HorrorBird, alt: 'Horror bird' })`
  width: 100%;
  max-width: 400px;
  height: auto;
  margin-top: auto;

  @media ${sizes.desktop} {
    align-self: flex-end;
    width: calc(100% - 400px);
    max-width: 810px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;

  > p {
    margin-top: 24px;
  }

  > button {
    margin-left: auto;
    margin-top: 24px;
  }

  @media ${sizes.desktop} {
    margin-top: 280px;
  }
`;

export const EmailInput = styled(TextInput)`
  margin-top: 24px;
`;

export const StyledSpinner = styled(Spinner)`
  margin-top: 60px;
`;

export const ErrorAlert = styled(Alert)`
  margin-top: 20px;
`;

export const WarningAlert = styled(Alert)`
  margin-top: 20px;
  > p > div {
    padding-bottom: 20px;
  }
`;
